import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { LoginComponent } from './components/login/login.component';
import { UsuariosComponent } from './components/usuarios/usuarios.component';
import { UsuarioFormComponent } from './components/usuarios/usuario-form/usuario-form.component';
import { CambiarPasswordComponent } from './components/usuarios/cambiar-password/cambiar-password.component';
import { MiPerfilComponent } from './components/usuarios/mi-perfil/mi-perfil.component';
import { BuscarEstudianteComponent } from './components/buscar-estudiante/buscar-estudiante.component';
import { EstudianteDetailComponent } from './components/estudiante-detail/estudiante-detail.component';
import { CentrosEntrenamientoComponent } from './components/centros-entrenamiento/centros-entrenamiento.component';
import { InstructoresComponent } from './components/instructores/instructores.component';
import { CalculadoraPromediosComponent } from './components/calculadora-promedios/calculadora-promedios.component';
import { EstudiantesListComponent } from './components/estudiantes-list/estudiantes-list.component';
import { ControlExamenComponent } from './components/control-examen/control-examen.component';
import { ItfDatabaseComponent } from './components/itf-database/itf-database.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { 
    path: '', 
    redirectTo: 'buscar-estudiante', 
    pathMatch: 'full'
  },
  { 
    path: 'usuarios', 
    component: UsuariosComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin'] }
  },
  { 
    path: 'usuarios/nuevo', 
    component: UsuarioFormComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin'] }
  },
  { 
    path: 'usuarios/editar/:id', 
    component: UsuarioFormComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin'] }
  },
  { 
    path: 'buscar-estudiante', 
    component: BuscarEstudianteComponent,
    canActivate: [AuthGuard]
  },
  { 
    path: 'estudiantes/:id', 
    component: EstudianteDetailComponent,
    canActivate: [AuthGuard],
  },
  { 
    path: 'estudiantes', 
    component: EstudiantesListComponent,
    canActivate: [AuthGuard]
  },
  { 
    path: 'centros-entrenamiento', 
    component: CentrosEntrenamientoComponent,
    canActivate: [AuthGuard]
  },
  { 
    path: 'instructores', 
    component: InstructoresComponent,
    canActivate: [AuthGuard]
  },
  { 
    path: 'calculadora-promedios', 
    component: CalculadoraPromediosComponent,
    canActivate: [AuthGuard]
  },
  { 
    path: 'control-examen', 
    component: ControlExamenComponent,
    canActivate: [AuthGuard], 
    data: { roles: ['admin', 'recepcion'] }
  },
  // ============================================================================
  // ITF DATABASE ROUTES
  // ============================================================================
  {
    path: 'itf-database',
    component: ItfDatabaseComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'mesa', 'recepcion'] }
  },
  // ============================================================================
  // USER MANAGEMENT
  // ============================================================================
  {
    path: 'mi-perfil',
    component: MiPerfilComponent, 
    canActivate: [AuthGuard],
  },
  {
    path: 'cambiar-password',
    component: CambiarPasswordComponent, 
    canActivate: [AuthGuard],
  },
  /*
  {
    path: 'usuarios',
    component: any, 
    canActivate: [AuthGuard], 
    data: { roles: ['admin'] }
  },
  */
  { path: '**', redirectTo: 'buscar-estudiante' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }